function money(value) {
  const safe = Number.isFinite(Number(value)) ? Number(value) : 0;
  return Math.round(Math.max(0, safe) * 100) / 100;
}

export function normalizeScheduledBookingPricingMode(value) {
  return String(value || "").trim().toUpperCase() === "DISCOUNT_REDUCES_TOTAL"
    ? "DISCOUNT_REDUCES_TOTAL"
    : "LEGACY_NO_DISCOUNT";
}

export function normalizeScheduledBookingDiscountPercent(value) {
  const safe = Number.isFinite(Number(value)) ? Number(value) : 0;
  if (safe <= 0) return 0;
  if (safe >= 100) return 100;
  return money(safe);
}

export function summarizeScheduledBookingAmounts({
  totalFare,
  bookingAmount,
  discountPercent = 0,
  pricingMode = "LEGACY_NO_DISCOUNT",
}) {
  const safeFare = money(totalFare);
  const originalBookingAmount = money(bookingAmount);
  const safePricingMode = normalizeScheduledBookingPricingMode(pricingMode);
  const safePercent =
    safePricingMode === "DISCOUNT_REDUCES_TOTAL"
      ? normalizeScheduledBookingDiscountPercent(discountPercent)
      : 0;
  const discountAmount = money((originalBookingAmount * safePercent) / 100);
  const effectiveBookingAmount = money(Math.max(0, originalBookingAmount - discountAmount));
  const pendingAfterRide = money(Math.max(0, safeFare - originalBookingAmount));
  return {
    pricingMode: safePricingMode,
    discountPercent: safePercent,
    originalBookingAmount,
    discountAmount,
    effectiveBookingAmount,
    pendingAfterRide,
    fullyWaived: effectiveBookingAmount <= 0.0001,
  };
}
